<template>

  <div>

    <v-client-table
      ref="tblInterface"
      :data="data"
      :columns="tblColumns"
      :options="tblOptions"
      class="tblInterface noFirstColumn">

      <template slot="created" slot-scope="props">

          <template v-if="props.row.created == null">
              -
          </template>
          <template v-else>
            {{ formatDate2(props.row.created, true) }}
          </template>

      </template>

      <template slot="status" slot-scope="props">

        <span :class="props.row.status">{{ props.row.status }}</span>

      </template>

      <template slot="description" slot-scope="props">
        <span v-if="props.row.status != 'RUNNING'" class="material-symbols-outlined visibility" @click="toggleChildRow(props)">visibility</span>
      </template>

      <template slot="metrics" slot-scope="props">

        <template v-if="props.row.metrics && !props.row.metrics.length && props.row.metrics.warnings && props.row.metrics.warnings.length > 0">

          <popover trigger="hover">
            <span class="material-symbols-outlined orange">info</span>
            <div slot="content">
              <span v-for="warning in props.row.metrics.warnings">{{ warning }}</span>
            </div>
          </popover>

        </template>

        <template v-else-if="props.row.status != 'RUNNING'">
          <!-- <span class="material-symbols-outlined green">check</span> -->
        </template>

        <template v-else>

        </template>

      </template>

      <template v-slot:child_row="props">

        <div class="child-description">
          <div v-for="desc in props.row.description">
            {{ desc.message }}
          </div>
        </div>

     </template>


    </v-client-table>
  </div>

</template>


<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');



export default {

	name: 'TableComponent',
  props: ['name', 'data'],

	data() {

		return {

			labels: [],
			tblColumns: ['created', 'details', 'status', 'duration', 'description', 'metrics'],
			tblOptions: {
        trackBy: 'id',
        uniqueKey: 'id',
				saveState: false,
				perPage: 25,
				orderBy: {
					ascending: false,
					column: 'created'
				},

        sortable: ['created', 'details', 'status'],

				headings: {
					created: function(h) {
						return <lang labelKey="INTERFACE_TBL_HEADER-CREATED"></lang>
					},
          status: function(h) {
            return <lang labelKey="INTERFACE_TBL_HEADER-STATUS"></lang>
          },
          duration: function(h) {
						return <lang labelKey="INTERFACE_TBL_HEADER-DURATION"></lang>
					},
					description: function(h) {
						return <lang labelKey="INTERFACE_TBL_HEADER-DESCRIPTION"></lang>
					},
          metrics: function(h) {
						return <lang labelKey="INTERFACE_TBL_HEADER-METRICS"></lang>
					},
					details: function(h) {
						return <lang labelKey="INTERFACE_TBL_HEADER-DETAILS"></lang>
					},
				},

        columnsClasses: {
            'created': 'created',
            'description': 'description',
            'metrics': 'metrics',
            'status': 'status',
            'duration': 'duration',
        },

        showChildRowToggler: false,

				filterByColumn: true,
        listColumns: {
            status: [
                {
                    id: "SUCCESS",
                    text: 'SUCCESS',
                    hide: true
                },
                {
                    id: "RUNNING",
                    text: 'RUNNING',
                    hide: true
                },
                {
                    id: "SKIPPED",
                    text: 'SKIPPED',
                    hide: true
                },
                {
                    id: "WARNING",
                    text: 'WARNING',
                    hide: true
                },
                {
                    id: "ERROR",
                    text: 'ERROR',
                    hide: true
                },
            ]
        },
				filterable: ['details', 'status'],
				// sortable: ['name', 'value'],
				sortIcon: {
					base:'fa',
					up:'fa-sort-up',
					down:'fa-sort-down',
					is:'fa-sort'
				},

				texts: {
					filter: 'Filter Ergebnisse:',
          filterBy: 'Filtern',
					filterPlaceholder: 'Suche',
					limit: 'Einträge pro Seite',
					noResults: 'keine passenden Einträge gefunden',
					count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag',
          defaultOption: "Filter nach Status",
				},

				pagination: {
					chunk: 5
				},

				skin: 'table is-striped is-hoverable is-fullwidth',
			}
		}
	},

  created() {

    if(this.data.length) {
      this.tblOptions.listColumns.status.forEach((s) => {
        s.hide = !this.data.some((d) => d.status == s.id);
      })
    } else {
      this.tblOptions.filterByColumn = false;
    }

  },

  mounted() {

  },

  methods: {

    toggleChildRow(props) {
      this.$refs.tblInterface.toggleChildRow(props.row.id);
    }

  }
}
</script>

<style lang="scss" scoped>

    ::v-deep .VuePagination {
      .pagination-list {
        list-style: none !important;
      }
    }
    ::v-deep .table {
      /*
      .VueTables__child-row-toggler {
          width: 16px;
          height: 16px;
          line-height: 16px;
          display: block;
          margin: auto;
          text-align: center;
      }
      /*
      .VueTables__child-row-toggler--closed::before {
          content: "+";
      }

      .VueTables__child-row-toggler--open::before {
          content: "-";
      }
      */


      .select {
        border-color: #dbdbdb;
        border-radius: 3px;
      }

      th:first-child {
        width: 180px;
        max-width: 180px;
      }
      th.status {
        width: 180px;
        max-width: 180px;
      }
      th.duration {
        width: 100px;
        max-width: 100px;
      }
      th.metrics,
      th.description {
        text-align: center;
        width: 70px;
        max-width: 70px;
      }

      .child-description {
        padding: 16px;
        white-space: normal;
      }

      td {
        cursor: default;
      }
      td.metrics,
      td.description {
        text-align: center;
        .material-symbols-outlined {
          font-size: 18px; // 16px;
          color: #888;

          &.orange {
            color: #f5aa3c;
          }
          &.green {
            color: #579866;
          }
          &:not(.green):hover {
            color: #222 !important;
          }
        }
      }
      td.description {
        .material-symbols-outlined {
          cursor: pointer;
        }
      }

      td.status {
        span {

          font-weight: bold;
          color: #999;

          &.SUCCESS {
            color: #579866;
          }
          &.RUNNING {
            color: rgba(69,164,212,.8); // color: #45a3d2;
          }
          &.SKIPPED {

          }
          &.WARNING {
            color: #f5aa3c;
          }

        }
      }

      .VueTables__child-row {
        td {
          cursor: default;
        }
      }


    }


</style>
